module.exports = __webpack_public_path__ + "static/media/arrow-left-white.e1ce87bd.svg";